import { Stack } from '@grubhubprod/gh-cookbook-react';
import cn from 'classnames';
import React from 'react';

interface DatePickerOverlayProps {
  children: React.ReactNode;
  classNames: Record<string, string>;
  selectedDay: Date;
  month: Date;
  input: HTMLInputElement;
  tabIndex: number;
  onBlur: () => void;
  onFocus: (e: React.FocusEvent) => void;
}

export function DatePickerOverlay({
  children,
  classNames: overlayClassNames,
  tabIndex,
  onFocus,
  onBlur,
}: DatePickerOverlayProps): JSX.Element {
  return (
    <div
      className={cn(
        overlayClassNames.overlayWrapper,
        'datePicker_overlayWrapper'
      )}
      tabIndex={tabIndex}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      <Stack position="absolute" paddingBottom="12px">
        <div
          className={overlayClassNames.overlay}
          style={{ position: 'static' }}
        >
          {children}
        </div>
      </Stack>
    </div>
  );
}
